function isSizeValid(file, maxSize) {
  return Number.isInteger(maxSize) && file.size <= maxSize;
}

export { isSizeValid };
//# sourceMappingURL=isSizeValid.mjs.map
